<div class="w-100">
    <div *ngFor="let file of files;let i = index;" class="col-12 p-2 flex justify-content-between">
        <div class="w-2rem flex align-items-center justify-content-center mr-2">
            <i class="far {{getIcon(file.name)}} text-5xl" [style.color]="getColor(file.name)"></i>
        </div>
        <div class="flex align-items-center overflow-hidden" style="width: 100%;">
            <span class="w-full overflow-hidden text-left text-overflow-ellipsis white-space-nowrap block">
                <a [href]="file.url" target="_blank" class="text-900 no-underline">{{file.name}}</a>
            </span>
        </div>
        <div *ngIf="type === 'EDIT'" class="flex align-items-center justify-content-center ml-2" style="width: 2.5rem;">
            <button pButton pRipple type="button" icon="far fa-trash-alt"
                class="p-button-rounded p-button-danger p-button-outlined" (click)="deleteFile(file, i)"></button>
        </div>
        <div *ngIf="type === 'DOWNLOAD'" class="flex align-items-center justify-content-center ml-2" style="width: 2.5rem;">
            <button pButton pRipple type="button" icon="fas fa-download"
                class="p-button-rounded p-button-success p-button-outlined" (click)="downloadFile(file)"></button>
        </div>
        <div *ngIf="type === 'DOWNLOAD_DELETE'"  style="min-width: 100px; text-align: right;">
            <button pButton pRipple type="button" icon="fas fa-download"
                class="p-button-rounded p-button-success p-button-outlined mr-2" (click)="downloadFile(file)"></button>
            <button pButton pRipple type="button" icon="far fa-trash-alt"
                class="p-button-rounded p-button-danger p-button-outlined" (click)="deleteFile(file, i)"></button>
        </div>
    </div>
</div>
